import {Injectable} from '@angular/core';
import {AlertController, ModalController, ToastController} from '@ionic/angular';
import {Locale} from 'src/app/model/locale';
import {PiantinaComponent} from 'src/app/shared/components/piantina/piantina.component';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private _toastController: ToastController,
              private modalController: ModalController,
              private alertController: AlertController) {
  }

  async presentAlert(header, subHeader, message, cssClass, buttons: any[] = [{text: 'OK'}]) {
    const alert = await this.alertController.create({
      cssClass,
      header,
      subHeader,
      message,
      buttons
    });

    await alert.present();

    const {role} = await alert.onDidDismiss();
    return role;
  }

  async presentToast(message: string, position: any = 'bottom') {
    const toast = await this._toastController.create({
      color: 'dark',
      duration: 5000,
      message,
      position,
      buttons: [
        {
          text: 'X',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    await toast.present();
  }

  async presentModal(component, componentProps: any, settings?: any) {
    const modal = await this.modalController.create({
      component,
      mode: 'ios',
      componentProps,
      ...settings
    });
    await modal.present();
    return modal.onWillDismiss();
  }

  openMap(locale: Locale, selectable = false) {
    return this.presentModal(PiantinaComponent, {selectable, locale});
  }

  dismiss(data: any) {
    return this.modalController?.dismiss(data);
  }
}
